import { ROUTES_CACHE_MS } from "@phone-booth/content/layout";

/**
 * The wording the screens share. Both of these are derived from a real value
 * rather than typed as a literal, so a screen cannot drift from what the phone
 * actually does.
 */

/** How long an edit can take to reach the phone, in words. */
export function cacheDelay(): string {
  const minutes = Math.max(1, Math.round(ROUTES_CACHE_MS / 60_000));
  return minutes === 1 ? "about a minute" : `about ${minutes} minutes`;
}

/**
 * The same delay again, shaped for "every ___". `cacheDelay` reads "about a
 * minute", which is right after "in" and "within" and wrong after "every".
 */
export function cacheEvery(): string {
  const minutes = Math.max(1, Math.round(ROUTES_CACHE_MS / 60_000));
  return minutes === 1 ? "minute" : `${minutes} minutes`;
}

export function messageCount(count: number): string {
  if (count === 0) return "No messages yet";
  return count === 1 ? "1 message" : `${count} messages`;
}
